import gql from "graphql-tag";

export const ROLE_BY_NAME_QUERY = gql`
  query GetRoleByNameQuery($name: String!) {
    role(where: { name: $name }) {
      ldapDN
      ldapUUID
      name
      scopes
      default
      users {
        id
        name
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/RoleQuery/queries.ts